export type InfoEntryProps = {
    description: string;
    value: string;
};

export const InfoEntry = ({ description, value, ...rest }: InfoEntryProps) => (
    <div className="flex gap-8 items-center" {...rest}>
        <div>
            <div className="font-bold" data-testid="description">
                {description}
            </div>
            <div data-testid="value">{value === 'Hytte/feriehjem' ? 'Feriehjem' : value}</div>
        </div>
    </div>
);
